export default "__VITE_ASSET__VN5EM4Op__"